module.exports = ":host {\n  display: block;\n  position: absolute;\n  bottom: -26px;\n  right: 20px;\n  z-index: 1000; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/add-button/add-button.component.scss
// module id = ./libs/atenea-cms/src/add-button/add-button.component.scss
// module chunks = main